import React, { useState } from "react";

import { getIcon } from "../../helpers/icons";
import DialogBox from './index';
import Button from "../../components/Field/Button";
import Editor from "../Editor";
import Link from "../Link";

import style from "./style.module.css";

const ShareDialog = ({ onClose }) => {

    const path = window.location.href;
    const [isCopied, setIsCopied] = useState(false);

    const ShareLinks = [
        { icon: getIcon("Whatsapp"), label: "Whatsapp", to: `https://api.whatsapp.com/send?text=` + encodeURIComponent(path) },
        { icon: getIcon("Facebook"), label: "Facebook", to: `https://www.facebook.com/sharer.php?u=${path}` },
        { icon: getIcon("Twitter"), label: "Twitter", to: `https://twitter.com/intent/tweet?url=${path}` },
        { icon: getIcon("Linkedin"), label: "Linkedin", to: `https://www.linkedin.com/sharing/share-offsite/?url=${path}` },
        { icon: getIcon("Envelope"), label: "Mail", to: `https://mail.google.com/mail/?view=cm&fs=1&to=&su=&body=${path}&bcc=` },
    ];

    const copyToClipboard = (text) => {
        if (navigator && navigator.clipboard) navigator.clipboard.writeText(text)
            .then(() => { setIsCopied(true) })
            .catch((error) => { alert(`Copy failed! ${error}`) });
    }

    return <DialogBox title={false} headerClass={style.shareDialogHeader} className={style.shareDialog} onClose={() => { onClose() }}>
        <div className={`${style.shareWrapper} ${style.popupArea}`}>
            <div className={style.shareItems}>
                {
                    ShareLinks.map(({ icon, label, to }) => {
                        return <div key={`${label}_share_link`} className={style.shareLinks}>
                            <Link target="_blank" to={to}>
                                <i className={icon}></i>
                            </Link>
                        </div>
                    })
                }
            </div>
            <div className={style.copyWrapper}>
                <Editor text={window.location.href} />
                <div className={style.actionButton}>
                    <Button 
                        color={"buttonPrimary"} 
                        onClick={() => copyToClipboard(window.location.href)} label={isCopied ? 'Copied' : 'Copy'} 
                    />
                </div>
            </div>
        </div>
    </DialogBox>
}

export default ShareDialog;